import request from "@/http/request"
import {
    updatePlace,
    addPlace,
    deletePlace,
    queryPlace,
    queryPlaceList,
    updatePlaceState,
    importPlace,
    queryAllPlace,
    getPlace,
    listTime,
    getPlaceMonitorQrCode,
    exportPlaceMonitorQrCode
} from '@/http/api'

export const exportPlaceMonitorQrCodeAPI = (data) => {
    return request({
        url: exportPlaceMonitorQrCode,
        data,
    })
}

export const getPlaceMonitorQrCodeAPI = (data) => {
    return request({
        url: getPlaceMonitorQrCode,
        data,
    })
}

export const courseListTime = (data) => {
    return request({
        url: listTime,
        data,
    })
}

export const getPlaceList = (data) => {
    return request({
        url: getPlace,
        data,
    })
}

export const addPlaceFn = (data) => {
    return request({
        url: addPlace,
        data
    })
}
export const deletePlaceFn = (data) => {
    return request({
        url: deletePlace,
        data
    })
}
export const updatePlaceStateFn = (data) => {
    return request({
        url: updatePlaceState,
        data
    })
}
export const updatePlaceFn = (data) => {
    return request({
        url: updatePlace,
        data
    })
}
export const getSinglePlace = (data) => {
    return request({
        url: queryPlace,
        data
    })
}
export const getAllPlace = (data) => {
    return request({
        url: queryPlaceList,
        data
    })
}
export const getSelectPlace = (data = {state: 1}) => {
    return request({
        url: queryAllPlace,
        data
    })
}
export const importPlaceFn = (data) => {
    return request({
        url: importPlace,
        data,
        isUpload:true
    })
}